/*
|--------------------------------------------------------------------------
| State
|--------------------------------------------------------------------------
*/

const state = {
  messageType: null,
  message: null,
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/

const actions = {
  setMessage({commit}, {type, message}) {
    commit("mutateMessage", {type, message});
  },

  clearMessage({commit}) {
    commit("mutateMessage", {type: null, message: null});
  },
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/

const mutations = {
  mutateMessage(state, {type, message}) {
    state.messageType = type;
    state.message = message;
  },
};

/*
|--------------------------------------------------------------------------
| Export
|--------------------------------------------------------------------------
*/

export const message = {
  namespaced: true,
  actions,
  mutations,
  state,
};
